import {
  ApplicantAngelInvestment,
  ApplicantAnotherExperience,
  ApplicantArticle,
  ApplicantAward,
  ApplicantCommunity,
  ApplicantCompany,
  ApplicantContest,
  ApplicantEducation,
  ApplicantEntrepreneurship,
  ApplicantMentorship,
  ApplicantMilestone,
  ApplicantOpenSource,
  ApplicantPatent,
  ApplicantProject,
  ApplicantPublicTalk,
} from "@prisma/client";

import { ApplicantCompanyFull, ApplicantProjectFull } from "@/lib/prisma";

export enum ExperienceType {
  Employment = "Employment",
  Entrepreneurship = "Entrepreneurship",
  PublicTalks = "Events",
  Articles = "Articles",
  Contests = "Contests",
  ScientificWorkOrPhD = "Scientific work or PhD",
  TeachingAndMentorship = "Teaching and Mentorship",
  Award = "Award you received",
  CommunityDevelopment = "Community development",
  OpenSourceContribution = "Open source contributions",
  Patent = "Patent you own(ed)",
  AngelInvestment = "Angel investment", // GOTCHA: Out of use, not used anymore, TODO: Drop it later (no actual database records exists, only test ones)
  AnotherExperience = "Other",
  MentionInMedia = "Mentions in media",
}

export enum ApplicationSectionName {
  Employment = "Employment",
  Entrepreneurship = "Entrepreneurship",
  ProfJourney = "Professional Journey",
  ExternalProfile = "External Profile",
  PotentialReferees = "Potential Referees",
  RefereesChoice = "Referees Choice",
  RefereeDetails = "Referee Details",
  StepDoc = "StepDoc",
}

export enum ProfJourneyExperienceType {
  Employment,
  Entrepreneurship,
  ConferenceYouOrganized,
  ContestYouOrganised,
  OpenSourceContribution,
  Mentorship,
  Teaching,
  CommunityDevelopment,
  AngelInvestment,
}

export enum ExternalExperienceType {
  ArticleYouWrote,
  ArticleYouReMentionedIn,
  ConferenceYouSpoke,
  ContestYouParticipatedIn,
  Award,
  Patent,
}

export enum SubExperienceType {
  Project = "Project",
  Milestone = "Milestone",
}

export type ApplicantExperience =
  | ApplicantCompany
  | ApplicantEntrepreneurship
  | ApplicantOpenSource
  | ApplicantMentorship
  | ApplicantEducation
  | ApplicantCommunity
  | ApplicantAngelInvestment
  | ApplicantArticle
  | ApplicantPublicTalk
  | ApplicantContest
  | ApplicantAward
  | ApplicantPatent
  | ApplicantAnotherExperience;

export type ApplicantSubExperience = ApplicantProject | ApplicantMilestone;

export const getExperienceSectionTitle = (
  experienceType: ExperienceType
): string => {
  switch (experienceType) {
    case ExperienceType.Employment:
      return "application:experience.section_title.employment";
    case ExperienceType.MentionInMedia:
      return "application:experience.section_title.MentionInMedia";
    case ExperienceType.ScientificWorkOrPhD:
      return "application:experience.section_title.scientificWorkOrPhD";
    case ExperienceType.Entrepreneurship:
      return "application:experience.section_title.entrepreneurship";
    case ExperienceType.Contests:
      return "application:experience.section_title.contests";
    case ExperienceType.OpenSourceContribution:
      return "application:experience.section_title.opensource";
    case ExperienceType.TeachingAndMentorship:
      return "application:experience.section_title.teaching_and_mentorship";
    case ExperienceType.CommunityDevelopment:
      return "application:experience.section_title.com_dev";
    case ExperienceType.AnotherExperience:
      return "application:experience.section_title.other";
    case ExperienceType.Articles:
      return "application:experience.section_title.articles";
    case ExperienceType.PublicTalks:
      return "application:experience.section_title.publicTalks";
    case ExperienceType.Award:
      return "application:experience.section_title.awards";
    case ExperienceType.Patent:
      return "application:experience.section_title.patents";
    default:
      return "";
  }
};

export interface ApplicantCompanyTmpField extends ApplicantCompanyFull {
  tmpFieldId: string;
}
export interface ApplicantCompanyTmpFieldList {
  data: ApplicantCompanyTmpField[];
}
export interface ApplicantProjectTmpField extends ApplicantProjectFull {
  tmpCompanyFieldId: string;
}
export interface ApplicantProjectTmpFieldList {
  data: ApplicantProjectTmpField[];
}

export interface ApplicantEntrepreneurshipTmpField
  extends ApplicantEntrepreneurship {
  tmpFieldId: string;
}
export interface ApplicantEntrepreneurshipTmpFieldList {
  data: ApplicantEntrepreneurshipTmpField[];
}
export interface ApplicantMilestoneTmpField extends ApplicantMilestone {
  tmpEntrepreneurshipFieldId: string;
}
export interface ApplicantMilestoneTmpFieldList {
  data: ApplicantMilestoneTmpField[];
}

export const isProjectBelongsToCompany = (
  companyField: ApplicantCompanyTmpField,
  projectField: ApplicantProjectTmpField
) => {
  return (
    (projectField.applicantCompanyId &&
      companyField.id &&
      projectField.applicantCompanyId === companyField.id) ||
    (projectField.tmpCompanyFieldId &&
      companyField.tmpFieldId &&
      projectField.tmpCompanyFieldId === companyField.tmpFieldId)
  );
};

export const isMilestoneBelongsToEntrepreneurship = (
  entrepreneurshipField: ApplicantEntrepreneurshipTmpField,
  milestoneField: ApplicantMilestoneTmpField
) => {
  return (
    (milestoneField.applicantEntrepreneurshipId &&
      entrepreneurshipField.id &&
      milestoneField.applicantEntrepreneurshipId ===
        entrepreneurshipField.id) ||
    (milestoneField.tmpEntrepreneurshipFieldId &&
      entrepreneurshipField.tmpFieldId &&
      milestoneField.tmpEntrepreneurshipFieldId ===
        entrepreneurshipField.tmpFieldId)
  );
};

export function getSubExperienceTypeByExperienceType(
  experienceType: ExperienceType
) {
  switch (experienceType) {
    case ExperienceType.Entrepreneurship:
      return SubExperienceType.Milestone;
    case ExperienceType.Employment:
      return SubExperienceType.Project;
    default:
      return null;
  }
}
